import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/styles";
import { Grid } from "@material-ui/core";

import Group242 from "assets/images/causes_inner/Group242.png";
import Group266 from "assets/images/causes_inner/grp3.jpg";
import Group267 from "assets/images/causes_inner/donat3.png";
import Group268 from "assets/images/causes_inner/ss2.jpg";
import Group269 from "assets/images/causes_inner/ss1.jpg";
import Group57 from "assets/images/causes/Group57.png";

import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

export default function Partners({ id }) {
  const classes = useStyles();

  useEffect(() => {}, []);

  return (
    <div>
      {id == 2 && (
        <div className={classes.container}>
          <Carousel autoPlay={true}>
            <div className={classes.innerInternational}>
              <div className={classes.innerWrapper}>
                <Grid container>
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <div className={classes.ourPartner}>Our Partners</div>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                    <img src={Group242} width="394" height="250" style={{objectFit: 'cover'}}/>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                    <div className={classes.aboutAeifer}>
                      <div className={classes.partnerHeading}>
                        Hiefer International
                      </div>
                      <div className={classes.bottomBorder}></div>
                      <p className={classes.partnerContent}>
                        Heifer International, operating in 21 countries, has
                        programs for economic development, environmental
                        sustainability, food security and nutrition, risk
                        mitigation and resilience, and women’s
                        empowerment/social capital. Heifer supports farmers,
                        helps communities, provides training to improve the
                        quantity and the quality of goods produced, and
                        establishes connections to increase incomes.
                      </p>
                    </div>
                  </Grid>
                </Grid>
              </div>
            </div>

            <div className={classes.innerInternational}>
              <div className={classes.innerWrapper}>
                <Grid container>
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <div className={classes.ourPartner}>Our Partners</div>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                    <img src={Group266} width="395" height="250" style={{objectFit: 'cover'}} />
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                    <div className={classes.aboutAeifer}>
                      <div className={classes.partnerHeading}>
                        Three Square Food Bank
                      </div>
                      <div className={classes.bottomBorder}></div>
                      <p className={classes.partnerContent}>
                        Relentlessly pursuing the stated goal that “No one in
                        our community should be hungry." In 2019, Three Square
                        distributed more than 41 million meals to the most
                        vulnerable. Bringing together the resources, experience
                        and passion of the people and businesses of Nevada,
                        Three Square is assuring that children, individuals and
                        seniors receive the food they need.
                      </p>
                    </div>
                  </Grid>
                </Grid>
              </div>
            </div>
          </Carousel>
        </div>
      )}
      {id == 1 && (
        <div className={classes.container}>
          <Carousel autoPlay={true}>
            <div className={classes.innerInternational}>
              <div className={classes.innerWrapper}>
                <Grid container>
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <div className={classes.ourPartner}>Our Partners</div>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                    <img src={Group267} width="394" height="250" style={{objectFit: 'cover'}} />
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                    <div className={classes.aboutAeifer}>
                      <div className={classes.partnerHeading}>
                        Operation Underground Railroad
                      </div>
                      <div className={classes.bottomBorder}></div>
                      <p className={classes.partnerContent}>
                        Fighting the worldwide global epidemic of child sex
                        trafficking, rescuing children from slavery and
                        assisting law enforcement in the prosecution of those
                        who violate children. Once victims are rescued,
                        continuing to support survivors on their path to
                        recovery by partnering with vetted aftercare providers.
                        O.U.R. operates in 26 countries around the world and 28
                        states in the US.
                      </p>
                    </div>
                  </Grid>
                </Grid>
              </div>
            </div>

            <div className={classes.innerInternational}>
              <div className={classes.innerWrapper}>
                <Grid container>
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <div className={classes.ourPartner}>Our Partners</div>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                    <img src={Group268} width="395" height="250" style={{objectFit: 'cover'}} />
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                    <div className={classes.aboutAeifer}>
                      <div className={classes.partnerHeading}>Thorn</div>
                      <div className={classes.bottomBorder}></div>
                      <p className={classes.partnerContent}>
                        Dedicated to ending child sex trafficking and the sexual
                        exploitation of children. “And we won’t stop until every
                        child can just be a kid.” Thorn provides services to
                        online platforms to proactively detect and delete abuse
                        content. Thorn is considered the world’s leader in
                        developing and depolying technology to fight human
                        trafficking and the Zwagil Foundation is proud to
                        partner with Thorn in this critical fight.
                      </p>
                    </div>
                  </Grid>
                </Grid>
              </div>
            </div>
          </Carousel>
        </div>
      )}
      {id == 4 && (
        <div className={classes.container}>
          <Carousel autoPlay={true}>
            <div className={classes.innerInternational}>
              <div className={classes.innerWrapper}>
                <Grid container>
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <div className={classes.ourPartner}>Our Partners</div>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                    <img src={Group269} width="394" height="250" style={{objectFit: 'cover'}} />
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                    <div className={classes.aboutAeifer}>
                      <div className={classes.partnerHeading}>Water.org</div>
                      <div className={classes.bottomBorder}></div>
                      <p className={classes.partnerContent}>
                        785 million people — about 1 in 9 — lack access to safe
                        water; 2 billion lack access to a toilet. Water.org is
                        dedicated to changing this, empowering families through
                        access to affordable financing and expert resources to
                        make household water and sanitation solutions a reality.
                        Join the Zwagil Foundation and our partner water.org in
                        this global effort to empower families to a safer and
                        better future.
                      </p>
                    </div>
                  </Grid>
                </Grid>
              </div>
            </div>
          </Carousel>
        </div>
      )}
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  container: {
    position: "relative",
    minHeight: 400,
  },
  innerInternational: {
    backgroundImage: `url(${Group57})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    padding: "40px 116px 78px 149px",
    height: "473px",

    "@media (max-width: 1230px)": {
      padding: "40px 30px 78px 30px",
    },
    "@media (max-width: 600px)": {
      height: "100%",
      padding: "35px",
    },

    "@media (min-width: 600px)": {
      height: "100%",
    },
  },
  ourPartner: {
    fontWeight: "bold",
    fontSize: 24,
    color: "#FFFFFF",
    textAlign: "center",
    paddingBottom: "40px",
    fontFamily: "Poppins",
    lineHeight: "46px",
  },
  partnerHeading: {
    fontWeight: "bold",
    fontSize: 20,
    color: "#FFFFFF",
    lineHeight: "30px",
    fontFamily: "Poppins",
    textAlign: "left",
  },
  bottomBorder: {
    padding: 2,
    borderRadius: 4,
    margin: "10px 0",
    width: "35px",
    background: "#3AC7FF",
  },
  partnerContent: {
    fontSize: 14,
    color: "#FFFFFF",
    opacity: 0.7,
    textAlign: "justify",
    lineHeight: "20px",
    width: "98%",
  },
  aboutAeifer: {
    marginLeft: 65,

    "@media (max-width: 600px)": {
      marginTop: 40,
      marginLeft: 0,
    },
  },
}));
